<div data-cy="confirm-dialog-container" class="confirm-dialog-container">
  <ng-container [ngTemplateOutlet]="template"></ng-container>
</div>
<div class="confirm-dialog-footer">
  <button data-cy="dialog-no" mat-flat-button class="mat-secondary" (click)="confirmAction('cancel')">
    {{ data?.cancelText }}
  </button>
  @if (data?.primaryButtonAction === 'offer') {
    <button data-cy="dialog-yes" mat-flat-button class="mat-primary ml-4" (click)="confirmAction('offer')">
      {{ data?.primaryButton }}
    </button>
  }
  @if (data?.primaryButtonAction === 'review') {
    <button data-cy="dialog-yes" mat-flat-button class="mat-primary ml-4" (click)="confirmAction('review')">
      {{ data?.primaryButton }}
    </button>
  }
  @if (data?.secondaryButtonAction === 'offerElect') {
    <button data-cy="dialog-yesElect" mat-flat-button class="mat-primary ml-4" (click)="confirmAction('offerElect')">
      {{ data?.secondaryButton }}
    </button>
  }
</div>
